import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../layout/loader';

function ProductDetailRedirect() {
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    axios.get(`/api/product/${id}`)
      .then(({ data }) => {
        const slug = data?.isDataGet?.slug || data?.isDataGet?._id || id;
        history.replace(`/product/${slug}`);
      })
      .catch(() => {
        // Fallback: if API fails, direct to /product/:id
        history.replace(`/product/${id}`);
      });
  }, [id, history]);

  return <Loader />;
}

export default ProductDetailRedirect;
